import { Button, Drawer } from "antd";
import secureIcon from "./../../../../assets/images/secure.svg";
import userIcon from "../../../../assets/images/user-purple.svg";
import calendarIcon from "../../../../assets/images/calendar.svg";

export const ConfirmSlotDrawer = ({
  LangSpecificMsgData,
  appointmentDetails,
  patientGender,
  patientAge,
  handleSubmitToDoctor,
  isSubmitLoading,
  continueBooking,
}: any) => {
  const appointmentDate = appointmentDetails.appointment_date || appointmentDetails.date;
  return (
    <Drawer
      placement="bottom"
      closeIcon={false}
      open={true}
      height="auto"
      className="rounded-t-2xl overflow-hidden p-0 max-w-[450px] mx-auto"
      push={false}
    >
      <div className="font-semibold text-lg pb-2">Confirm Slot</div>
      <section className="flex justify-center flex-col gap-5 w-70 text-base font-medium tracking-normal leading-loose text-center w-full">
        <div className="bg-[#FAFAFB] rounded-2xl p-5 flex flex-col shadow-sm">
          <div className="flex items-center justify-center gap-3 border-b border-[#F2F4F7] pb-3">
            <img src={userIcon} alt="user" />
            <span className="font-medium text-sm">
              {appointmentDetails?.pm_first_name ||
                appointmentDetails?.patient_name ||
                appointmentDetails?.name}{" "}
              {patientGender && patientAge?.years
                ? `(${patientGender}, ${patientAge?.years} yrs )`
                : null}
            </span>
          </div>
          <div className="flex items-center justify-center gap-3 pt-2">
            <img src={calendarIcon} alt="calendar" />
            <span className="font-medium text-sm">
              {(appointmentDetails?.appointment_date ||
                appointmentDetails?.date) &&
              appointmentDetails?.appointment_start_time
                ? `${new Date(appointmentDate).toLocaleDateString("en-US", {
                    day: "numeric",
                    month: "short",
                    year: "2-digit",
                  })} | ${appointmentDetails.appointment_start_time}`
                : ""}
            </span>
          </div>
          <div className="text-xs text-center mt-2">
            With{" "}
            {appointmentDetails?.doctor_name ||
              appointmentDetails?.um_name ||
              appointmentDetails?.doctors_name}
          </div>
        </div>
        <Button
          className={`overflow-hidden gap-2 self-stretch px-14 py-2 bg-[#ed8a000a] whitespace-nowrap rounded-xl border border-[#ED8A0033] border-solid flex justify-center w-full h-[50px] text-lg font-medium text-[#ED8A00]`}
          onClick={continueBooking}
        >
          {"No, I want to add more "}
        </Button>
        <Button
          className={`flex justify-center overflow-hidden gap-2 self-stretch px-14 py-2 text-white bg-indigo-600 whitespace-nowrap rounded-xl border border-indigo-600 border-solid w-full h-[50px] text-lg font-medium`}
          onClick={handleSubmitToDoctor}
          loading={isSubmitLoading}
        >
          {appointmentDetails?.pam_id
            ? LangSpecificMsgData.rescheduleAppointment
            : LangSpecificMsgData.confirmSlot}
        </Button>
        <div className="flex gap-2 justify-center opacity-40 mix-blend-luminosity">
          <img src={secureIcon} alt="secure-icon" />
          <div className="text-xs text-[#454551]">
            Your Data is Secured & only doctor can access it
          </div>
        </div>
      </section>
    </Drawer>
  );
};
